/** Fallback MediaRecorder timeslice when init does not return chunkDurationMs. */
export const DEFAULT_CHUNK_DURATION_MS = 15 * 1000

/** Live chunk duration returned by recording/init (MediaRecorder timeslice). */
export const INIT_CHUNK_DURATION_MS = 30 * 1000

/**
 * Bound wait after MediaRecorder.stop() for a late dataavailable (Safari).
 * Keeps flush from racing ahead of the last blob enqueue.
 */
export const RECORDER_STOP_DATA_WAIT_MS = 2000

/**
 * Grace after INTERVIEW_DONE / RESULT_COMPLETED during which wrap-up APIs
 * (part-url mint, session-log append) may still succeed. Covers an in-flight
 * chunk, the stop() flush chunk, and one extra timeslice of upload slack.
 * Sized to the live init timeslice (30s), not the 15s fallback default.
 */
export const COMPLETED_WRAPUP_GRACE_MS = INIT_CHUNK_DURATION_MS * 3

/**
 * Frame rate of the interview recording. The canvas compositor draws and captures at this rate, and the camera and
 * screen share ask for it too (`ideal`, so devices that can't still work) — so every source feeds the recording at a
 * steady 30fps instead of whatever the device defaults to.
 */
export const RECORDING_FRAME_RATE = 30
